import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from '../functions/config';

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faBook,
  faUsers,
  faListCheck,
  faCartShopping,
  faBagShopping,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";

const RegisterBook = () => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const [bookDetails, setBookDetails] = useState({
    title: "",
    author: "",
    publisher: "",
    stock: 0,
    price: 0,
    image: null,
  });

  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      image: file,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", bookDetails.title);
      formData.append("author", bookDetails.author);
      formData.append("publisher", bookDetails.publisher);
      formData.append("stock", bookDetails.stock);
      formData.append("price", bookDetails.price);
      if (bookDetails.image) {
        formData.append("image", bookDetails.image);
      }

      const response = await fetch(`${config.BASE_URL}/api/register-book/`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setNotification({ type: "success", message: "Book registered successfully!" });
        setTimeout(() => {
          navigate("/view-books");
        }, 3000);
      } else {
        setNotification({ type: "error", message: "Failed to register the book." });
      }

      setBookDetails({
        title: "",
        author: "",
        publisher: "",
        stock: 0,
        price: 0,
        image: null,
      });
    } catch (error) {
      console.error("Error registering the book:", error);
      setNotification({ type: "error", message: "An error occurred. Please try again." });
    }
  };

    // Auto-dismiss notification after 3 seconds
    useEffect(() => {
      if (notification) {
        const timer = setTimeout(() => setNotification(null), 3000);
        return () => clearTimeout(timer);
      }
    }, [notification]);

    

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-dark fixed-top">
      <div className="container-fluid">
        <a className="navbar-brand text-light" href="#">Admin</a>
        <button 
          className="navbar-toggler bg-light" 
          type="button" 
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
            <li className="nav-item">
              <Link className="nav-link text-light" to="/admin">
                <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/register-book">
                <FontAwesomeIcon icon={faBook} className="me-2 text-warning" />
                Register Book
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/list-users">
                <FontAwesomeIcon icon={faUsers} className="me-2" />
                Manage User
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/view-books">
                <FontAwesomeIcon icon={faListCheck} className="me-2" />
                Manage Book
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/adminpurchase">
                <FontAwesomeIcon icon={faCartShopping} className="me-2" />
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/adminrent">
                <FontAwesomeIcon icon={faBagShopping} className="me-2" />
                Rental History
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto pr-5">
            <li className="nav-item mr-5">
              <Link className="nav-link text-light fixed-right" to="/login">
                <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    {/* Book Registration Form */}
<div className="container content px-5 mt-5 pt-2">
  <h2 className="my-4 text-center">Register a New Book</h2>

  {notification && (
        <div
          style={{
            position: "fixed",
            top: "30px",
            right: "20px",
            backgroundColor: notification.type === "success" ? "#28a745" : "#dc3545",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 9999,
          }}
        >
          {notification.message}
        </div>
      )}

      
  <div className="form-container mx-auto">
    <form onSubmit={handleSubmit} encType="multipart/form-data">
      <div className="mb-3">
        <label className="form-label">Book Title</label>
        <input
          type="text"
          className="form-control"
          name="title"
          value={bookDetails.title}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Author</label>
        <input
          type="text"
          className="form-control"
          name="author"
          value={bookDetails.author}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Publisher</label>
        <input
          type="text"
          className="form-control"
          name="publisher"
          value={bookDetails.publisher}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Stock</label>
        <input
          type="number"
          className="form-control"
          name="stock"
          value={bookDetails.stock}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Price</label>
        <input
          type="number"
          className="form-control"
          name="price"
          value={bookDetails.price}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Book Cover Image</label>
        <input
          type="file"
          className="form-control"
          name="image"
          onChange={handleFileChange}
          accept="image/*"
        />
      </div>
      <button type="submit" className="btn btn-primary">
        Register Book
      </button>
    </form>
  </div>
</div>

      <style jsx>{`
 

  .form-container {
    max-width: 500px;
    width: 100%;
    padding: 15px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1); /* Dark background color */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  
        .content {
          margin-left: 200px;
        }
        @media (max-width: 768px) {
          .vertical-nav {
            width: 100%;
          }
          .content {
            margin-left: 0;
          }
        }
  .navbar {
    background: #1a1a1a; /* Dark background color */
  }

  .vertical-nav {
    background: #1a1a1a; /* Dark background color */
    position: fixed;
    top: 56px;
    left: 0;
    height: calc(100% - 56px);
    overflow-y: auto;
    padding-top: 30px;
    z-index: 999;
  }

  .vertical-nav .nav-link {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 15px;
    color: #ff6700; /* Dark orange font color */
    transition: background-color 0.3s; /* Smooth hover effect */
  }

  .vertical-nav .nav-link:hover {
    background-color: #2a2a2a; /* Slightly lighter background for hover effect */
  }

  .nav-icon {
    font-size: 20px;
    margin-right: 10px;
    color: #ff6700; /* Dark orange for icons */
  }

  li {
    border-bottom: 2px solid black;
  }

  li:hover {
    background-color: #2a2a2a; /* Slightly lighter background for hover effect */
  }


  .btn {
    width: 100%; /* Full-width button */
    background-color: #ff6700; /* Dark orange background for button */
     maxWidth: 400px,

    color: white;
    border: none;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
  }

  .btn:hover {
    background-color: #e65c00; /* Darker orange on hover */
    cursor: pointer;
  }

  body {
    position: relative;
    margin: 0; /* Remove default margins */
    padding: 0; /* Remove default padding */
  }

  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
    background-size: cover; /* Ensure the image covers the entire body */
    opacity: 0.4; /* Apply opacity only to the image */
    z-index: -1; /* Place it behind all other content */
  }

  a {
    text-decoration: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "Times New Roman", Times, serif; /* Classic font */
    color: #1a1a1a; /* Match the theme color */
  }
      `}</style>
    </div>
  );
};

export default RegisterBook;
